module.exports = __webpack_public_path__ + "media/images/partner/supporter/veedelslieben-ecfba2f01c4446e48c8d2029f8082f35.png";